var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{attrs:{"headers":_vm.headers,"data":_vm.items,"loading":_vm.isLoading,"hide-delete":true,"hide-edit":true,"hide-table-bottom":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }